import { createFileRoute } from '@tanstack/react-router'
import { WasteStationPage } from 'pages/app/waste-station/WasteStationPage'

export const Route = createFileRoute('/_authenticated/app/mottagsstation/$id')({
  component: WasteStationPage,
})
